import { FunctionComponent } from 'react'
import styles from './planningKPI.module.scss'
import { CalendarEventType } from '@/types/Calendar.ts'
import Indicator from '@/components/_custom/Indicator/indicator.tsx'
import { useTranslation } from 'react-i18next'

interface ParentKPIProps {
    filterEvents: (filters: string[]) => void
    availableHours: number
    validatedHours: number
    isParent: boolean
}

const ParentKPI: FunctionComponent<ParentKPIProps> = ({
    filterEvents,
    availableHours,
    validatedHours,
    isParent
}: ParentKPIProps) => {
    const { t } = useTranslation()

    return (
        <>
            <a className={styles.IndicatorClickable} onClick={() => filterEvents([CalendarEventType.AVAILABLE])}>
                <Indicator
                    count={availableHours}
                    parent={isParent}
                    size={'m'}
                    text={availableHours > 1 ? t('availableHours') : t('availableHour')}
                    className={styles.Indicator}
                    badge={'available'}
                />
            </a>
            <a className={styles.IndicatorClickable} onClick={() => filterEvents([CalendarEventType.VALIDATED])}>
                <Indicator
                    count={validatedHours}
                    parent={isParent}
                    size={'m'}
                    text={validatedHours > 1 ? t('validatedHours') : t('validatedHour')}
                    className={styles.Indicator}
                    badge={'booked'}
                />
            </a>
        </>
    )
}

export default ParentKPI
